import { gql } from "@apollo/client";
import { gtag, install } from "ga-gtag";

import apolloClient from "./apolloClient";
import { GA_MEASURE_ID, ONSEN_APP } from "./environment";
import { progressBar } from "./useProgressBar";

export function initGA() {
  if (ONSEN_APP) return;
  install(GA_MEASURE_ID, {
    send_page_view: false,
    // gtag.js loads async, so pin the URL we booted on before the app can navigate away from it.
    page_location: window.location.href,
  });
}

const gaEventSharedParams = {};

export function gaSetSharedEventParams(params) {
  const oldOrgId = gaEventSharedParams.org_id;
  Object.assign(gaEventSharedParams, params);
  const newOrgId = gaEventSharedParams.org_id;
  if (newOrgId !== oldOrgId) {
    progressBar(async () => {
      let orgAnalyticsName = null;
      if (newOrgId) {
        const result = await apolloClient.query({
          query: gql`
            query gaSetSharedEventParams($id: ID!) {
              org(id: $id) {
                gaId
                analyticsName
              }
            }
          `,
          variables: { id: newOrgId },
          fetchPolicy: "cache-first",
        });
        orgAnalyticsName = result.data?.org?.analyticsName;
      }
      gaEventSharedParams.org_name = orgAnalyticsName;
    });
  }
}

export function gaEvent(eventName, params) {
  // TODO: gtag won't work in Capacitor runtime as for now. Implement this through firebase SDK instead.
  if (ONSEN_APP) return;
  return gtag("event", eventName, {
    // Report the URL the event happened on, not the one pinned at install time.
    page_location: window.location.href,
    ...gaEventSharedParams,
    ...params,
  });
}
